import { render, staticRenderFns } from "./waterway.vue?vue&type=template&id=4045bb51&scoped=true&"
import script from "./waterway.vue?vue&type=script&lang=js&"
export * from "./waterway.vue?vue&type=script&lang=js&"
import style0 from "./waterway.vue?vue&type=style&index=0&id=4045bb51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045bb51",
  null
  
)

export default component.exports